import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  VStack,
  Heading,
  Input,
  Button,
  Text,
  InputGroup,
  InputRightElement,
  IconButton,
  useToast,
  Container,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";

const AdminLogin = () => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();

  // Temporar - hardcoded password (poți schimba cu verificare din backend)
  const ADMIN_PASSWORD = "mattias2025"; 

  const handleLogin = (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Simulare verificare (poți înlocui cu API call)
    setTimeout(() => {
      if (password === ADMIN_PASSWORD) {
        // Salvează token în localStorage
        localStorage.setItem("admin_authenticated", "true");
        localStorage.setItem("admin_login_time", new Date().toISOString());
        
        toast({
          title: "Login successful! 🎉",
          description: "Welcome to Mattias Admin Panel",
          status: "success",
          duration: 2000,
          position: "top",
        });

        // Redirect la dashboard
        setTimeout(() => {
          navigate("/admin/dashboard");
        }, 500);
      } else {
        toast({
          title: "Access Denied ❌",
          description: "Invalid password. Please try again.",
          status: "error",
          duration: 3000,
          position: "top",
        });
      }
      setIsLoading(false);
    }, 800);
  };

  return (
    <Box
      minH="100vh"
      bgGradient="linear(to-br, gray.900, gray.800, teal.900)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="relative"
      overflow="hidden"
    >
      {/* Background decoration */}
      <Box
        position="absolute"
        top="-20%"
        right="-10%"
        width="500px"
        height="500px"
        borderRadius="full"
        bg="teal.500"
        opacity={0.1}
        filter="blur(100px)"
      />
      <Box
        position="absolute"
        bottom="-20%"
        left="-10%"
        width="400px"
        height="400px"
        borderRadius="full"
        bg="purple.500"
        opacity={0.1}
        filter="blur(100px)"
      />

      <Container maxW="md" position="relative" zIndex={1}>
        <Box
          bg="rgba(26, 32, 44, 0.95)"
          p={8}
          borderRadius="2xl"
          border="1px solid"
          borderColor="whiteAlpha.200"
          backdropFilter="blur(20px)"
          boxShadow="0 20px 60px rgba(0,0,0,0.5)"
        >
          <VStack spacing={6} as="form" onSubmit={handleLogin}>
            {/* Header */}
            <VStack spacing={2}>
              <Box fontSize="4xl">🔐</Box>
              <Heading
                size="lg"
                bgGradient="linear(to-r, teal.300, cyan.400)"
                bgClip="text"
                textAlign="center"
              >
                Admin Access
              </Heading>
              <Text color="gray.400" fontSize="sm" textAlign="center">
                Mattias Portfolio Management
              </Text>
            </VStack>

            {/* Password Input */}
            <VStack spacing={4} w="full">
              <Box w="full">
                <Text fontSize="sm" color="gray.400" mb={2} fontWeight="medium">
                  Password
                </Text>
                <InputGroup size="lg">
                  <Input
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter admin password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    bg="whiteAlpha.100"
                    border="1px solid"
                    borderColor="whiteAlpha.300"
                    _hover={{ borderColor: "whiteAlpha.400" }}
                    _focus={{
                      borderColor: "teal.400",
                      boxShadow: "0 0 0 1px var(--chakra-colors-teal-400)",
                    }}
                    color="white"
                  />
                  <InputRightElement>
                    <IconButton
                      size="sm"
                      variant="ghost"
                      icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
                      onClick={() => setShowPassword(!showPassword)}
                      aria-label="Toggle password visibility"
                      color="gray.400"
                      _hover={{ color: "white" }}
                    />
                  </InputRightElement>
                </InputGroup>
              </Box>

              {/* Login Button */}
              <Button
                type="submit"
                w="full"
                size="lg"
                bgGradient="linear(to-r, teal.400, cyan.500)"
                color="white"
                fontWeight="bold"
                _hover={{
                  bgGradient: "linear(to-r, teal.500, cyan.600)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 20px rgba(56, 178, 172, 0.4)",
                }}
                _active={{ transform: "translateY(0)" }}
                isLoading={isLoading}
                loadingText="Authenticating..."
              >
                Login to Admin
              </Button>
            </VStack>

            {/* Footer info */}
            <Box
              w="full"
              p={3}
              bg="whiteAlpha.50"
              borderRadius="lg"
              border="1px solid"
              borderColor="whiteAlpha.100"
            >
              <Text fontSize="xs" color="gray.500" textAlign="center">
                🔒 Secure access only for authorized administrators
              </Text>
            </Box>
          </VStack>
        </Box>

        {/* Back to main site link */}
        <Text textAlign="center" mt={4} fontSize="sm" color="gray.500">
          Not an admin?{" "}
          <Text
            as="span"
            color="teal.300"
            cursor="pointer"
            _hover={{ textDecoration: "underline" }}
            onClick={() => navigate("/")}
          >
            Back to Portfolio →
          </Text>
        </Text>
      </Container>
    </Box>
  );
};

export default AdminLogin;